import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { purchaseRedemption } from 'api/purchase'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  PurchaseRedemptionTxFormTypes,
  PurchaseRedemptionTxFormSubmitValuesTypes,
  PurchaseRedemptionTxFormSubmitActionsTypes,
} from 'types/purchaseTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const PURCHASEREDEMPTIONTXINITVAL: PurchaseRedemptionTxFormTypes = {
  transactionValue: 0,
  creditValue: 0,
  loyaltyValue: 0,
  externalTransactionId: 0,
  ident: '',
  storeId: 0,
  deviceCode: '',
  cashier: '',
  guid: '',
  transactionDate: '',
  transactionDetail: [],
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const usePurchaseRedemptionTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: PurchaseRedemptionTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleMerchantSet: (merchant: MerchantLookupTypes[]) => void
  handleSubmitPurchaseRedemptionTx: (
    values: PurchaseRedemptionTxFormSubmitValuesTypes,
    actions: PurchaseRedemptionTxFormSubmitActionsTypes
  ) => void
  handleClearPurchaseRedemptionTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseRedemptionTxMerchant, purchaseRedemptionTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] = useState<PurchaseRedemptionTxFormTypes>({
    ...PURCHASEREDEMPTIONTXINITVAL,
    cashier: authTokenUsername,
    externalTransactionId: formatter.externalIdentification(),
    ident: String(member?.cardNumber) || '',
  })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleMerchantSet = useCallback(
    async (merchant: MerchantLookupTypes[]) => {
      try {
        purchaseRedemptionTxMerchantSet(merchant)
        toast.success('Merchant Selected')
      } catch (error) {
        toast.error('Something went wrong.')
      }
    },
    [purchaseRedemptionTxMerchantSet]
  )

  const handleSubmitPurchaseRedemptionTx = useCallback(
    async (
      values: PurchaseRedemptionTxFormSubmitValuesTypes,
      actions: PurchaseRedemptionTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        await purchaseRedemption(values)
        toast.success('Purchase/Loyalty redemption transaction successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearPurchaseRedemptionTx = useCallback(() => {
    initialValuesSet({ ...PURCHASEREDEMPTIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleMerchantSet,
    handleSubmitPurchaseRedemptionTx,
    handleClearPurchaseRedemptionTx,
  }
}
